var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        maskClosable: false,
        confirmLoading: _vm.confirmLoading,
        okText: this.$store.getters.language["common.okButton"],
        destroyOnClose: true,
        cancelText: this.$store.getters.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules }
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: this.$store.getters.language[
                      "sys.SysCategoryList.parentNode"
                    ],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "pid"
                  }
                },
                [
                  _c("j-tree-select", {
                    ref: "treeSelect",
                    attrs: {
                      placeholder:
                        this.$store.getters.language["common.pleaseInput"] +
                        this.$store.getters.language[
                          "sys.SysCategoryList.parentNode"
                        ],
                      dict: "sys_category,name,id",
                      pidField: "pid",
                      pidValue: "0",
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.model.pid,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "pid", $$v)
                      },
                      expression: "model.pid"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: this.$store.getters.language[
                      "sys.SysCategoryList.name"
                    ],
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "name"
                  }
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        this.$store.getters.language["common.pleaseInput"] +
                        this.$store.getters.language["sys.SysCategoryList.name"]
                    },
                    model: {
                      value: _vm.model.name,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }